<template>
  <div style="width: 100%">
    <div class="section1">
      <div style="width: 1024px">
        <h1>云付收银宝是一款集成多通道支付接口的收款工具，全面支持 支付宝，微信，云闪付，数字货币，pos刷卡，挥卡闪付</h1>
          <div style="margin-top: 30px;font-size:20px;font-weight: bold;background-color: #409eff66;padding:20px">
              <h3>轻松开店专业收钱</h3>
           <pre>

支持收银员扫客户付款码，掌握收款主动权
支持客户扫商家二维码，解放收银双手
支持公众号/小程序支付，让您家公众号/小程序拥有收款能力
支持云mis，电脑下单一键同步到pos，刷卡完成后自动入账
收款软硬件灵活搭配
扫码立牌，云音箱，智能扫码盒，智能pos，收款小程序，微信收款单，支付表单，满足您的个性化收款需求
        </pre>
          </div>
          <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: space-around;">
              <img style="object-fit: contain;height: 500px;margin-bottom: 15px" src="../assets/img/p/1.jpg" />
              <img style="object-fit: contain;height: 500px;margin-bottom: 15px" src="../assets/img/p/3.jpg" />
          </div>
          <div style="font-size:20px;font-weight: bold;background-color: #409effaa;padding:20px">
              <h3>团购核销</h3>
              <pre>

支持美团/抖音团购券核销，买单效率棒棒哒~
        </pre>
          </div>
          <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: space-around;">
              <img style="object-fit: contain;height: 500px;margin-bottom: 15px" src="../assets/img/p/2.jpg" />
              <img style="object-fit: contain;height: 500px;margin-bottom: 15px" src="../assets/img/p/4.jpg" />
          </div>
          <div style="font-size:20px;font-weight: bold;background-color: #409effaa;padding:20px">
              <h3>开放支付技术</h3>
              <pre>
提供聚合支付接口，对接自有系统，深度融合自有业务，打通经营全闭环
        </pre>
          </div>
          <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: space-around;">
              <img style="object-fit: contain;height: 500px;margin-bottom: 15px" src="../assets/img/p/5.jpg" />
              <img style="object-fit: contain;height: 500px;margin-bottom: 15px" src="../assets/img/p/6.jpg" />
          </div>
          <div style="font-size:20px;font-weight: bold;background-color: #409effaa;padding:20px">
              <h3>提供定制化开发服务</h3>
              <pre>
有需求，您就来，专业提供定制化开发服务，满足您的更多可能
        </pre>
          </div>
          <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: space-around;">
              <img style="object-fit: contain;height: 500px;margin-bottom: 15px" src="../assets/img/p/7.png" />
              <img style="object-fit: contain" src="../assets/img/p/8.jpg" />
          </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },
  created() {},
  computed: {
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.section1{
    width:100%;
    padding-top:50px;
    display: flex;
    justify-content: center;
    color:white;
    background:
            url('../assets/img/home_do.jpg') no-repeat center top,
            url('../assets/img/home_top.jpg') no-repeat center 1080px,
            url('../assets/img/home_do.jpg') no-repeat center bottom;
}
</style>
